import { useMemo, useState } from "react";
import { latestLeaks } from "@/mocks/home";

const tabs = [
  { key: "all", label: "全部爆料" },
  { key: "hot", label: "高热度" },
  { key: "photo", label: "画面图集" },
  { key: "talk", label: "讨论密集" },
];

const heatValue = (heat: string) => Number.parseFloat(heat.replace("w", "")) || 0;

export default function LatestLeaks() {
  const [active, setActive] = useState("all");

  const list = useMemo(() => {
    if (active === "hot") return latestLeaks.filter((item) => heatValue(item.heat) >= 70);
    if (active === "photo")
      return latestLeaks.filter((item) => item.tags.some((t) => t === "同框画面" || t === "路透照片"));
    if (active === "talk") return latestLeaks.filter((item) => Number.parseInt(item.comments.replace(/,/g, ""), 10) >= 900);
    return latestLeaks;
  }, [active]);

  return (
    <section id="latest" className="w-full bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <span className="text-xs font-bold uppercase tracking-widest text-primary-600">Latest Drops</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">最新爆料</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              按更新时间与讨论密度排列，每条都附上相关标签，点开能顺着线索继续往下查。
            </p>
          </div>

          <div className="inline-flex w-fit flex-wrap items-center gap-1 rounded-full bg-background-200/80 p-1">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActive(tab.key)}
                className={
                  active === tab.key
                    ? "whitespace-nowrap rounded-full bg-primary-500 px-4 py-1.5 text-sm font-semibold text-background-50 dark:text-foreground-950 cursor-pointer"
                    : "whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-medium text-foreground-600 transition-colors hover:text-primary-700 cursor-pointer"
                }
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="relative h-44 w-full">
                <img
                  src={item.image}
                  alt={item.title}
                  title={item.title}
                  className="h-full w-full object-cover object-top"
                />
                <div className="absolute inset-x-0 top-0 flex flex-wrap gap-1.5 p-3">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-md bg-background-50/90 px-2 py-0.5 text-[11px] font-semibold text-primary-800 backdrop-blur"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                  {item.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line text-sm"></i>
                    {item.time}
                  </span>
                  <span className="flex items-center gap-3">
                    <span className="flex items-center gap-1 font-semibold text-accent-700">
                      <i className="ri-fire-fill"></i>
                      {item.heat}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-chat-3-line"></i>
                      {item.comments}
                    </span>
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>

        {list.length === 0 && (
          <p className="mt-8 rounded-lg border border-dashed border-background-300 bg-background-50 py-10 text-center text-sm text-foreground-500">
            该分类下暂时没有条目，换个标签看看。
          </p>
        )}

        <div className="mt-9 flex justify-center">
          <button
            type="button"
            className="flex h-11 items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 bg-background-50 px-6 text-sm font-semibold text-primary-800 transition-colors hover:bg-primary-100 cursor-pointer"
          >
            <i className="ri-loader-4-line text-base"></i>
            加载更早的爆料
          </button>
        </div>
      </div>
    </section>
  );
}